import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './cta2.css'

const CTA2 = (props) => {
  return (
    <div className="cta2-container1 thq-section-padding">
      <div className="cta2-max-width thq-section-max-width">
        <div className="cta2-container2">
          <h2 className="cta2-text10">
            {props.heading ?? (
              <Fragment>
                <span className="cta2-text37">Benefits You Actually Feel</span>
              </Fragment>
            )}
          </h2>
          <div className="cta2-container3">
            <div className="cta2-container4">
              <h3 className="cta2-text11">
                {props.heading2 ?? (
                  <Fragment>
                    <span className="cta2-text35">
                      🔧 Operational Efficiency
                    </span>
                  </Fragment>
                )}
              </h3>
              <ul className="cta2-ul1 list">
                <li className="list-item">
                  <span>
                    {props.text ?? (
                      <Fragment>
                        <span className="cta2-text50">
                          Dedicated professionals in each admin function
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
                <li className="list-item">
                  <span>
                    {props.text1 ?? (
                      <Fragment>
                        <span className="cta2-text36">
                          Seamless coordination — no juggling vendors or
                          freelancers
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
                <li className="list-item">
                  <span>
                    {props.text2 ?? (
                      <Fragment>
                        <span className="cta2-text40">
                          Tasks completed faster, with fewer errors
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
              </ul>
            </div>
            <div className="cta2-container5">
              <h3 className="cta2-text15">
                {props.heading3 ?? (
                  <Fragment>
                    <span className="cta2-text39">💰 Massive Cost Savings</span>
                  </Fragment>
                )}
              </h3>
              <ul className="cta2-ul2 list">
                <li className="list-item">
                  <span>
                    {props.text3 ?? (
                      <Fragment>
                        <span className="cta2-text48">
                          Fixed monthly fee = predictable budgeting
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
                <li className="list-item">
                  <span>
                    {props.text4 ?? (
                      <Fragment>
                        <span className="cta2-text42">
                          No recruitment, no salaries, no end-of-service
                          liabilities
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
                <li className="list-item">
                  <span>
                    {props.text5 ?? (
                      <Fragment>
                        <span className="cta2-text46">
                          Zero training or onboarding delays
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
              </ul>
            </div>
            <div className="cta2-container6">
              <h3 className="cta2-text19">
                {props.heading4 ?? (
                  <Fragment>
                    <span className="cta2-text34">
                      📈 Scalability &amp; Growth
                    </span>
                  </Fragment>
                )}
              </h3>
              <ul className="cta2-ul3 list">
                <li className="list-item">
                  <span>
                    {props.text6 ?? (
                      <Fragment>
                        <span className="cta2-text38">
                          Scale services up or down based on your business size
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
                <li className="list-item">
                  <span>
                    {props.text7 ?? (
                      <Fragment>
                        <span className="cta2-text44">
                          Flexible support — from startup mode to expansion
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
                <li className="list-item">
                  <span>
                    {props.text8 ?? (
                      <Fragment>
                        <span className="cta2-text45">
                          Only pay for what you need, when you need it
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
              </ul>
            </div>
            <div className="cta2-container7">
              <h3 className="cta2-text23">
                {props.heading5 ?? (
                  <Fragment>
                    <span className="cta2-text33">
                      🔐 100% Compliance, Zero Risk
                    </span>
                  </Fragment>
                )}
              </h3>
              <ul className="cta2-ul4 list">
                <li className="list-item">
                  <span>
                    {props.text9 ?? (
                      <Fragment>
                        <span className="cta2-text41">
                          Stay compliant with UAE labor law, VAT, and WPS
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
                <li className="list-item">
                  <span>
                    {props.text10 ?? (
                      <Fragment>
                        <span className="cta2-text43">
                          Avoid costly fines, renewals, and license lapses
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
                <li className="list-item">
                  <span>
                    {props.text11 ?? (
                      <Fragment>
                        <span className="cta2-text49">
                          Expert advisory for government relations and policy
                          changes
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
              </ul>
            </div>
            <div className="cta2-container8">
              <h3 className="cta2-text27">
                {props.heading6 ?? (
                  <Fragment>
                    <span className="cta2-text47">
                      🤝 Relationship-Driven Service
                    </span>
                  </Fragment>
                )}
              </h3>
              <ul className="cta2-ul5 list">
                <li className="list-item">
                  <span>
                    {props.text12 ?? (
                      <Fragment>
                        <span className="cta2-text31">
                          Dedicated point of contact
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
                <li className="list-item">
                  <span>
                    {props.text13 ?? (
                      <Fragment>
                        <span className="cta2-text51">
                          Transparent communication
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
                <li className="list-item">
                  <span>
                    {props.text14 ?? (
                      <Fragment>
                        <span className="cta2-text32">
                          Proactive problem-solving, not reactive firefighting
                        </span>
                      </Fragment>
                    )}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CTA2.defaultProps = {
  text12: undefined,
  text14: undefined,
  heading5: undefined,
  heading4: undefined,
  heading2: undefined,
  text1: undefined,
  heading: undefined,
  text6: undefined,
  heading3: undefined,
  text2: undefined,
  text9: undefined,
  text4: undefined,
  text10: undefined,
  text7: undefined,
  text8: undefined,
  text5: undefined,
  heading6: undefined,
  text3: undefined,
  text11: undefined,
  text: undefined,
  text13: undefined,
}

CTA2.propTypes = {
  text12: PropTypes.element,
  text14: PropTypes.element,
  heading5: PropTypes.element,
  heading4: PropTypes.element,
  heading2: PropTypes.element,
  text1: PropTypes.element,
  heading: PropTypes.element,
  text6: PropTypes.element,
  heading3: PropTypes.element,
  text2: PropTypes.element,
  text9: PropTypes.element,
  text4: PropTypes.element,
  text10: PropTypes.element,
  text7: PropTypes.element,
  text8: PropTypes.element,
  text5: PropTypes.element,
  heading6: PropTypes.element,
  text3: PropTypes.element,
  text11: PropTypes.element,
  text: PropTypes.element,
  text13: PropTypes.element,
}

export default CTA2
